import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import UserProgressContext from "../../userProgressContext";
import SoundManager from "../../services/SoundManager";
import { saveUserProgress } from "../../services/saveUserProgress";

const ResourceDetails = () => {
  const {
    audioMuted,
    name,
    emailId,
    totalScore,
    setTotalScore,
    setCurrentTool,
    finishedTasks,
    redeemedScores,
  } = useContext(UserProgressContext);
  const navigate = useNavigate();
  const location = useLocation();
  const state = location && location.state;
  const { previousLocationPathname, resourceObj, currScript } = state && state;

  if (!resourceObj) {
    navigate("/page-not-found");
  }
  const handleGoBackBtn = () => {
    SoundManager.playSfx('game-retro-click');
    setTimeout(() => {
      navigate(-1);
    }, 100);
  };
  const handleResourcePurchase = (resourceId, resourcePoints) => {
    SoundManager.playSfx('points-collection');
    const newScore = parseInt(totalScore) - parseInt(resourcePoints);
    saveUserProgress({
      name: name,
      emailId: emailId,
      totalScore: newScore,
      redeemedScores: redeemedScores,
      finishedTasks: finishedTasks,
    });
    setTimeout(() => {
      setTotalScore(newScore);
      setCurrentTool(resourceId);

      navigate(previousLocationPathname, {
        state: {
          previousLocationPathname: "/gridGuardArsenal",
          crossover: true,
        },
      });
    }, 250);
  };
  return (
    <React.Fragment>
      {resourceObj && (
        <div className="relative flex flex-col h-full py-8">
          <div className="absolute top-0 left-0">
            <button
              className="hover:cursor-pointer hover:bg-indigo-600 transition-all ease-in delay-100 bg-indigo-500 text-white py-2 px-8 rounded-lg text-sm md:text-xl"
              onClick={handleGoBackBtn}
            >
              Go Back
            </button>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold mt-12 md:mt-4 mb-2 md:mb-4 text-center">
            {resourceObj.label}
          </h2>
          <div className="relative bg-white  flex flex-col items-center gap-4 p-4 md:p-8 border rounded-lg">
            <div className="absolute top-2 right-2 p-2 border border-green-500 text-green-500">
              <p className="text-lg font-bold">
                Purchase Cost: {resourceObj.points} points
              </p>
            </div>
            <div className="flex flex-col md:flex-row items-center gap-4 py-4 mt-12 md:mt-4">
              <div className="flex items-center basis-1/4">
                <img
                  src={require(`../../static/images/arsenalIcons/${resourceObj.iconName}.png`)}
                  alt={resourceObj.label}
                  className="w-36 md:w-48  rounded-lg shadow-xl shadow-zinc-500"
                />
              </div>
              <div className="flex items-center basis-2/3 text-gray-700 mt-4 md:mt-0">
                <p className="text-lg">{resourceObj.description}</p>
              </div>
            </div>
            {currScript &&
              "ggaTool" in currScript &&
              currScript["ggaTool"] === resourceObj.id &&
              (finishedTasks
                ? "taskId" in currScript &&
                  !finishedTasks.has(currScript["taskId"])
                : true) && (
                <button
                  className={`${
                    resourceObj.points > totalScore ? "invisible" : "visible"
                  } hover:cursor-pointer hover:bg-green-600 transition-all ease-in delay-100 bg-green-500 text-white py-2 px-8 rounded-lg text-sm md:text-xl`}
                  onClick={() =>
                    handleResourcePurchase(resourceObj.id, resourceObj.points)
                  }
                >
                  Purchase
                </button>
              )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ResourceDetails;
